<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-insert-chart`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 5a1 1 0 011 1v33h36a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h2zm11 17a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V23a1 1 0 011-1h2zm11-7a1 1 0 011 1v19a1 1 0 01-1 1h-2a1 1 0 01-1-1V16a1 1 0 011-1h2zm11-7a1 1 0 011 1v26a1 1 0 01-1 1h-2a1 1 0 01-1-1V9a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconInsertChart',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
